import { baseUrl, apiUrl, assetUrl } from '@/config/config'
var axios = require("axios").default;

// const localData = (JSON.parse(localStorage.getItem('token')) === null) ? window.location.href = '/' : JSON.parse(localStorage.getItem('token'));
// const token = localData.token
export default class Recipient {
    async RecipientDetail_OD(data) {
        console.log("dfndlk od",data)
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}recipientInformation/fetch_recipient_information_od/${data}`,
                headers: {
                    'Content-type': 'application/json',
                    // Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };
    async RecipientDetail_OS(data) {
        console.log("dfndlk os",data)
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}recipientInformation/fetch_recipient_information_os/${data}`,
                headers: {
                    'Content-type': 'application/json',
                    // Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };
    async SurgeonList() {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}users/view/hospital_surgeon`,
                headers: {
                    'Content-type': 'application/json',
                    // Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };
   

    async RecipientDetail() {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}recipientInformation/view_all`,
                headers: {
                    'Content-type': 'application/json',
                    // Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };
}